"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewbuilderStore = exports.ViewbuilderState = void 0;
const ViewBuilderStore_1 = require("../../base/api/viewBuilderTyped/ViewBuilderStore");
const viewBuilderGraph_1 = require("../../base/api/viewBuilderTyped/viewBuilderGraph");
const JsonUtil_1 = require("../../base/cutil/JsonUtil");
const LangUtil_1 = require("../../base/cutil/LangUtil");
const StoreBase_1 = require("../../base/cutil/StoreBase");
const CardDataServiceUtil_1 = require("../cardDataSearch/CardDataServiceUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const lodash_1 = require("lodash");
class ViewbuilderState {
    constructor() {
        this.viewBuilderLocalState = {};
        this.viewBuilderGraph = new viewBuilderGraph_1.ViewBuilderGraph();
        this.viewbuilderComponentsPath = undefined;
    }
    copyWith(param) {
        const newState = new ViewbuilderState();
        newState.viewBuilderGraph =
            JsonUtil_1.JsonUtil.toModelFromType(viewBuilderGraph_1.ViewBuilderGraph, param.viewBuilderGraph) ?? this.viewBuilderGraph;
        newState.viewbuilderComponentsPath = param.viewbuilderComponentsPath ?? this.viewbuilderComponentsPath;
        newState.viewBuilderLocalState = param.viewBuilderLocalState ?? this.viewBuilderLocalState;
        return newState;
    }
}
exports.ViewbuilderState = ViewbuilderState;
class ViewbuilderStore extends StoreBase_1.StoreBase {
    constructor(brainClient, cardDataManager) {
        super(() => new ViewbuilderState());
        this.brainClient = brainClient;
        this.cardDataManager = cardDataManager;
    }
    setViewbuilderState(param) {
        const newState = this.state.copyWith(param);
        this.emit(newState);
    }
    /**
     * 重置所有状态
     * @param viewBuilderGraph
     */
    init(viewBuilderGraph) {
        const newState = new ViewbuilderState();
        this.setViewbuilderState({ ...newState, viewBuilderGraph });
        this.defaultExecuteAllBlueprint();
    }
    getViewbuilderComponentsPath() {
        const viewbuilderComponentsPath = {};
        const designs = this.state.viewBuilderGraph?.design;
        (0, lodash_1.forEach)(designs, (design, designIndex) => {
            (0, lodash_1.forEach)(design.section_list, (section, sectionIndex) => {
                (0, lodash_1.forEach)(section.component_list, (component, componentIndex) => {
                    if (component.blueprint_id) {
                        viewbuilderComponentsPath[component.blueprint_id] = [
                            "design",
                            designIndex,
                            "section_list",
                            sectionIndex,
                            "component_list",
                            componentIndex,
                        ];
                    }
                });
            });
        });
        this.setViewbuilderState({ viewbuilderComponentsPath });
        return viewbuilderComponentsPath;
    }
    async executeBlueprint(userInputs, id) {
        const vbData = this.state.viewBuilderGraph;
        const component = CardDataServiceUtil_1.CardDataServiceUtil.findComponent(id, vbData);
        const bluePrintInfo = CardDataServiceUtil_1.CardDataServiceUtil.updateBluePrintInfo(id, vbData, userInputs);
        if (!vbData || !component || !bluePrintInfo) {
            console.error("vb data is empty");
            return Promise.reject("data is empty");
        }
        this.setViewBuilderLocalState(id, {
            loading: true,
        });
        const componentResult = await (0, LangUtil_1.tryPromise)(this.cardDataManager.searchComponentData(bluePrintInfo, component.component_id, vbData.app_description, bluePrintInfo.inputs[0].value));
        this.setViewBuilderLocalState(id, {
            loading: false,
        });
        if (componentResult.data) {
            this.setViewBuilderLocalState(id, {
                data: componentResult.data,
            });
        }
        else {
            console.error("error: ", componentResult.error);
        }
        return Promise.resolve();
    }
    /**
     * 第一次加载数据, 如果 input_users 都有value值, 默认执行一次
     */
    async defaultExecuteAllBlueprint() {
        const userInputs = this.state.viewBuilderGraph?.user_inputs;
        const isAllInputsHaveValue = (0, lodash_1.every)(userInputs, input => (0, is_blank_1.default)(input.value) === false);
        if ((0, is_blank_1.default)(userInputs) === false && isAllInputsHaveValue) {
            /**
             * 需要默认执行，那么不添加mock数据, 增加标识
             */
            (0, lodash_1.forEach)(this.state.viewBuilderGraph?.blueprints, blueprint => {
                this.setViewBuilderLocalState(blueprint.id, {
                    noUseMockData: true,
                });
            });
            await this.executeAllBlueprint(userInputs);
        }
    }
    async executeAllBlueprint(allUserInputs) {
        const promises = (0, lodash_1.map)(this.state.viewBuilderGraph?.blueprints, blueprint => {
            return this.executeBlueprint(allUserInputs, blueprint.id);
        });
        await Promise.all(promises);
    }
    transformToInputs(userInputs) {
        return (0, lodash_1.map)(userInputs, input => {
            return {
                value: input.data?.textAreaValue,
                name: input.data?.generatedLabel,
                user_input_id: input.data?.viewbuilderGraphUserInputId,
                description: input.data?.placeholder,
            };
        });
    }
    getComponentPath(id) {
        const pathMapping = (0, is_blank_1.default)(this.state.viewbuilderComponentsPath)
            ? this.getViewbuilderComponentsPath()
            : this.state.viewbuilderComponentsPath;
        const path = pathMapping[id];
        return path;
    }
    updateGraph(id, key, value) {
        const path = this.getComponentPath(id);
        if (path === undefined) {
            console.log("can not find blueprint id");
            return;
        }
        const newGraph = (0, lodash_1.cloneDeep)(this.state.viewBuilderGraph);
        (0, lodash_1.set)(newGraph, [...path, key], value);
        this.setViewbuilderState({ viewBuilderGraph: newGraph });
    }
    getComponentAttribute(id, attrName) {
        const path = this.getComponentPath(id);
        if (path === undefined) {
            console.log("can not find blueprint id");
            return undefined;
        }
        return (0, lodash_1.get)(this.state.viewBuilderGraph, [...path, attrName]);
    }
    getViewBuilderLocalState(id) {
        if (this.state.viewBuilderLocalState[id]) {
            return this.state.viewBuilderLocalState[id];
        }
        const data = this.getComponentAttribute(id, "data");
        return new ViewBuilderStore_1.LocalStateValue(data);
    }
    setViewBuilderLocalState(id, states) {
        const localState = this.getViewBuilderLocalState(id);
        const newLocalState = Object.assign({}, this.state.viewBuilderLocalState, {
            [id]: { ...localState, ...states },
        });
        const newState = this.state.copyWith({ viewBuilderLocalState: newLocalState });
        this.emit(newState);
    }
}
exports.ViewbuilderStore = ViewbuilderStore;
